/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

// Took from grafana repo:
// https://github.com/grafana/grafana/blob/main/packages/grafana-ui/src/utils/colors.ts
export const getColorsForQuestionState = (questionState) => {
  switch (questionState) {
    case -100:
      // pending
      return {
        backgroundColor: "#ffc400",
        color: "#ffffff",
      };
    case 0:
      // incoming
      return {
        backgroundColor: "#5c677c",
        color: "#c4c9d3",
      };
    case 200:
      // live
      return {
        backgroundColor: "#81daf6",
        color: "#ffffff",
      };
    case 300:
      // answered
      return {
        backgroundColor: "#92cf5c",
        color: "#fbfdfa",
      };
    case 400:
      // deleted
      return {
        backgroundColor: "#979797",
        color: "#fff",
      };
    default:
  }
};

/**
 * - the name is a bit misleading, these colors are both darkish and palish
 * - thus there is not a fixed background color that could be used to determine the contrast for the entire set
 */
export const HI_CONSTRAST_COLOR = [
  "#A6D87A", // 0: pale green
  "#FDD073", // 1: orange
  "#81DAF6", // 2: light blue
  "#FC8D80", // 3: light red
  "#9DA8FF", // 4: lilac
  "#4867E6", // 5: violet
  "#B75DA3", // 6: purple
  "#FCB880", // 7: pale orange
  "#59AF86", // 8: dark green
  "#CCA300", // 9: dark sand
  "#447EBC",
  "#C15C17",
  "#890F02",
  "#0A437C",
  "#6D1F62",
  "#584477",
  "#B7DBAB",
  "#F4D598",
  "#70DBED",
  "#F9BA8F",
  "#F29191",
  "#82B5D8",
  "#E5A8E2",
  "#AEA2E0",
  "#629E51",
  "#E5AC0E",
  "#64B0C8",
  "#E0752D",
  "#BF1B00",
  "#0A50A1",
  "#962D82",
  "#614D93",
  "#9AC48A",
  "#F2C96D",
  "#65C5DB",
  "#F9934E",
  "#EA6460",
  "#5195CE",
  "#D683CE",
  "#806EB7",
  "#3F6833",
  "#967302",
  "#2F575E",
  "#99440A",
  "#58140C",
  "#052B51",
  "#511749",
  "#3F2B5B",
  "#E0F9D7",
  "#FCEACA",
  "#CFFAFF",
  "#F9E2D2",
  "#FCE2DE",
  "#BADFF4",
  "#F9D9F9",
  "#DEDAF7",
];

/**
 * - colors that have high contrast on white background #FFFFFF
 * - checked with: https://webaim.org/resources/contrastchecker/
 * - complies with 3:1 contrast ratio --> Graphical Objects and User Interface Components: WCAG AA
 */
export const HIGH_CONTRAST_COLOR_FOR_FG_ON_WHITE_BG_GRAPHICS = [
  "#65A32E",
  "#CA8702",
  "#0EA1CD",
  "#FC604F",
  "#7A8AFF",
  "#4867E6",
  "#B75DA3",
  "#EC6C04",
  "#4EA27B",
  "#B38F00",
  "#447EBC",
  "#C15C17",
  "#890F02",
  "#0A437C",
  "#6D1F62",
  "#584477",
  "#3C6C2D",
  "#C18815",
  "#17A2BA",
  "#F46B10",
  "#EE6868",
  "#549AC9",
  "#D56CCE",
  "#9788D7",
  "#629E51",
  "#42A0BD",
  "#E0752D",
  "#BF1B00",
  "#0A50A1",
  "#962D82",
  "#614D93",
  "#BD890F",
  "#2CA0BA",
  "#F16609",
  "#EA6460",
  "#5195CE",
  "#D071C6",
  "#806EB7",
  "#3F6833",
  "#967302",
  "#2F575E",
  "#99440A",
  "#58140C",
  "#052B51",
  "#511749",
  "#3F2B5B",
  "#45A61C",
  "#CA850C",
  "#00A1B3",
  "#E37831",
  "#FC5F4A",
  "#289DD7",
  "#DD5FDD",
  "#8F82E3",
];

/**
 * - colors that have high contrast on white background #FFFFFF
 * - checked with: https://webaim.org/resources/contrastchecker/
 * - complies with 4.5:1 contrast ratio --> Normal and large Text: WCAG AA
 */
export const HIGH_CONTRAST_COLOR_FOR_FG_ON_WHITE_BG_TEXT = [
  "#518325",
  "#9D6902",
  "#0B7FA2",
  "#E71A04",
  "#4D61FF",
  "#B2539D",
  "#BF5803",
  "#3F8364",
  "#1F45E0",
  "#8F7200",
  "#4178B4",
  "#BB5816",
  "#890F02",
  "#0A437C",
  "#6D1F62",
  "#584477",
  "#3C6C2D",
  "#9C6E11",
  "#138296",
  "#C35309",
  "#E72323",
  "#367CAB",
  "#C337BA",
  "#7966CC",
  "#4E8042",
  "#347D93",
  "#BA5B1C",
  "#B81800",
  "#0A50A1",
  "#962D82",
  "#614D93",
  "#976D0C",
  "#238095",
  "#C55307",
  "#E22822",
  "#3279B3",
  "#BF40B3",
  "#7A65B3",
  "#3F6833",
  "#886802",
  "#2F575E",
  "#99440A",
  "#58140C",
  "#052B51",
  "#511749",
  "#3F2B5B",
  "#398717",
  "#9F6809",
  "#00818F",
  "#BC5B1A",
  "#E71E04",
  "#207DAC",
  "#C62AC6",
  "#7565DC",
];
